import type { PApiCollection } from '@model/dto/papi-collection';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

type GetOptsFn = (page: number) => AxiosRequestConfig;

export async function papiFetchAllPagesClient<T>(
    client: AxiosInstance,
    getOptsFn: GetOptsFn,
): Promise<AxiosResponse<PApiCollection<T>>[]> {
    const responses: AxiosResponse<PApiCollection<T>>[] = [];
    let currentPage = 1;
    let haveMoreToLoad = true;

    while (haveMoreToLoad) {
        const opts = getOptsFn(currentPage);

        // eslint-disable-next-line no-await-in-loop
        const response = await client.request<PApiCollection<T>>(opts);

        if (!response.data.data) {
            throw new Error(`Fetch failed: ${response.request.path}`);
        }

        responses.push(response);
        haveMoreToLoad = response.data.pagination.pages_total > currentPage;
        currentPage++;
    }

    return responses;
}
